<template>
  <div class="sms-numbers-settings brdr_content_wrpr">
    <h3 class="brdr_content_title">SMS settings
    <span class="new-tag">
	    New
    </span>
    </h3>

	  <div class="layout-row clickable-section" @click="popupOpen = true">
		  <div class="flex">
			  <p style="font-weight: 600;">SMS settings</p>
			  <p>Easily send high-converting SMS messages to your contacts from within your
				  funnel automations
				  without the need for any 3rd party apps.</p>
		  </div>
		  <div class="flex-none right-panel balance" style="min-width: 140px">
			  <v-spinner v-if="loading" />
			  <span class="label" v-if="smsAccount && smsAccount.balance<3">
				  Insufficient credit!
			  </span>
		  </div>
	  </div>

	  <popup-backdrop v-if="popupOpen" @close="popupOpen=false">
		  <sms-settings-popup @close="popupOpen=false;load()" @done="popupOpen=false;load()" :funnel="funnel" />
	  </popup-backdrop>
  </div>
</template>

<script>
import API from "@/api"
import PopupBackdrop from "@/components/base/popup-backdrop";
import SmsSettingsPopup from "@/views/funnels/funnel-plus/funnel/sms_numbers/sms_settings_popup";
import VSpinner from "@/components/base/v-spinner";

export default {
    name: 'SmsNumbersSettings',
  props: ["funnel"],
  mixins: [API],
  components: {VSpinner, SmsSettingsPopup, PopupBackdrop},
  data: function (){
      return {
        loading: false,
        popupOpen: false,
	      smsAccount:{},
      }
  },
  computed: {

  },
  mounted() {
  },
  methods: {
	  async load() {
		  try {
			  this.loading = true;
			  this.smsAccount = {};

			  this.smsAccount = await this.api.sms.getSmsAccount();
		  } catch (e) {
			  this.$error(e);
		  } finally {
			  this.loading = false;
		  }
	  },
  },
	created() {
			this.load();
	}
}
</script>

<style lang="scss" scoped>
.sms-numbers-settings {
	.brdr_content_title .new-tag {
		margin-left: 5px;
		font-size: 11px;
		background: lightgreen;
		color: darkgreen;
		padding: 3px 6px;
		border-radius: 5px;
	}
}
.clickable-section {
  border-top: 1px solid whitesmoke;
  border-bottom: 1px solid whitesmoke;
  padding: 0 10px;
  cursor: pointer;
  background: white;
  pointer-events: auto;
  transition: .2s all ease-in-out;

  &:hover {
    background: #f6f9fd;
    border-top: 1px solid #4268df;
    border-bottom: 1px solid #4268df;

    .label {
      color: #4268df;
    }
  }
  .right-panel {
    position: relative;
    display: flex;

    > .label {
      font-weight: bold;
      margin: auto;
	    display: inline-block;
	    text-align: center;
	    margin-left: 30px;
	    color: $light-red;
    }
  }
}
</style>
